import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Cross from '#components/svg/icons/Cross'

export class ActiveFilterBar extends Component {
  render() {
    const {filterRules, toggleFilterRule} = this.props
    return (
      <div className="activeFilterBar">
        <span>Angewendete Filter:</span>
        <div className="afb__items">
          {filterRules.map(rule => (
            <div key={rule.rule} className="afb__border">
              <span>{rule.rule}</span>
              <span
                role="button"
                tabIndex={0}
                className="afb__cross"
                onClick={() => toggleFilterRule(rule)}
                onKeyPress={() => toggleFilterRule(rule)}
              >
                <Cross />
              </span>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

ActiveFilterBar.propTypes = {
  toggleFilterRule: PropTypes.func.isRequired,
  filterRules: PropTypes.array.isRequired,
}

export default ActiveFilterBar
